import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { BRAND_VALUE_FILTER_TYPE, NAVIGATION_PATH_FILTER_TYPE, isFilterKeyOfType } from "@faire/retailer-shared/filters/filterKeys";
import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import fetchCategoryPageLayoutElements from "@faire/web-api--source/api/layout/category-page/post";
import { ICategoryPageLayoutRequest } from "@faire/web-api--source/indigofair/data/ICategoryPageLayoutRequest";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
export var useLoggedOutCategoryPageLayoutElementsResponse = function() {
    /**
     * we only need to send brand value filters to BE
     * as only these filters would affect meta tags
     */ var filter_keys = useCategoryPageFilterKeys().filter(function(filterKey) {
        return isFilterKeyOfType(filterKey, BRAND_VALUE_FILTER_TYPE) || isFilterKeyOfType(filterKey, NAVIGATION_PATH_FILTER_TYPE);
    });
    var navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
    return useQuery({
        queryKey: [
            navigationPath,
            filter_keys
        ],
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                fetchCategoryPageLayoutElements(ICategoryPageLayoutRequest.build({
                                    navigation_path: navigationPath,
                                    filter_keys: filter_keys
                                }), undefined, {
                                    signal: signal
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        staleTime: Infinity,
        placeholderData: keepPreviousData
    });
};
